import { Checkbox } from "@mui/material";
import { ReactComponent as IcCheckbox } from "./ADSProductCheckbox.svg";
import { ReactComponent as IcCheckboxActive } from "./ADSProductCheckboxActive.svg";

const ADSProductCheckbox = ({ selected, onSelect }) => {
  return (
    <Checkbox
      onChange={onSelect}
      color="primary"
      checked={selected}
      icon={<IcCheckbox style={{ width: "100%", height: "100%" }} />}
      checkedIcon={
        <IcCheckboxActive style={{ width: "100%", height: "100%" }} />
      }
      sx={{
        color: "#FB4764",
        padding: "0",
        width: 18,
        margin: "0",
        borderRadius: 5,
      }}
    />
  );
};

export default ADSProductCheckbox;
